<button
  #triggerBtn
  type="button"
  class="tt-filter-icon-btn"
  [class.tt-filter-icon-btn--active]="hasValue || panelOpen"
  [disabled]="disabled"
  [attr.aria-label]="panelTitle"
  [attr.title]="triggerTitle"
  [attr.aria-expanded]="panelOpen"
  [attr.aria-haspopup]="'dialog'"
  (click)="togglePanel()"
>
  <app-vocab-icon name="calendar"></app-vocab-icon>
  <span *ngIf="hasValue" class="tt-filter-icon-btn__badge" aria-hidden="true"></span>
</button>

<div
  #panelEl
  *ngIf="panelOpen"
  class="tt-filter-overlay-panel fixed"
  [ngStyle]="panelStyle"
  role="dialog"
  [attr.aria-label]="panelTitle"
  (mousedown)="onPanelPointerDown($event)"
>
  <div class="tt-filter-overlay-panel__title">{{ panelTitle }}</div>
  <div class="flex flex-col gap-3">
    <ng-container *ngIf="mode === 'single'; else rangeFields">
      <div>
        <label class="tt-filter-label" [for]="idPrefix + '-date'">{{ singleLabel }}</label>
        <input
          [id]="idPrefix + '-date'"
          [type]="inputType"
          [placeholder]="inputType === 'text' ? placeholder : null"
          [attr.inputmode]="inputType === 'text' ? 'numeric' : null"
          [ngModel]="dateFrom || ''"
          (ngModelChange)="onFromInput($event)"
          (blur)="onBlur()"
          class="input tt-filter-control"
        />
      </div>
    </ng-container>
    <ng-template #rangeFields>
      <div>
        <label class="tt-filter-label" [for]="idPrefix + '-from'">{{ fromLabel }}</label>
        <input
          [id]="idPrefix + '-from'"
          [type]="inputType"
          [placeholder]="inputType === 'text' ? placeholder : null"
          [attr.inputmode]="inputType === 'text' ? 'numeric' : null"
          [ngModel]="dateFrom || ''"
          (ngModelChange)="onFromInput($event)"
          (blur)="onBlur()"
          class="input tt-filter-control"
        />
      </div>
      <div>
        <label class="tt-filter-label" [for]="idPrefix + '-to'">{{ toLabel }}</label>
        <input
          [id]="idPrefix + '-to'"
          [type]="inputType"
          [placeholder]="inputType === 'text' ? placeholder : null"
          [attr.inputmode]="inputType === 'text' ? 'numeric' : null"
          [ngModel]="dateTo || ''"
          (ngModelChange)="onToInput($event)"
          (blur)="onBlur()"
          class="input tt-filter-control"
        />
      </div>
    </ng-template>
  </div>
  <button
    *ngIf="hasValue"
    type="button"
    class="mt-3 text-xs text-primary-600 dark:text-primary-400 hover:underline"
    (click)="clearValues()"
  >
    Zrušit období
  </button>
</div>
